// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"ErrorBoundary_errorWrapper__REeBI","icon":"ErrorBoundary_icon__0JU02","text":"ErrorBoundary_text__8Z5fn"};